// Configuración de la PWA Técnicos
export const API_URL = `${process.env.REACT_APP_FAST_API_URL || ''}/api`;
export const PORTAL_URL = process.env.REACT_APP_NODE_API_URL  || '';

const CONFIG = {
   APP_NAME: 'PestCleaner Tech',
   VERSION: '1.0.1',
   LANGUAGE: (window.localStorage.getItem('lang') || navigator.language?.slice(0,2) || 'en')
};

export default CONFIG;
